import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    // Redirect tutto al backend eGATE
    window.location.href = '/api/';
  }, []);
  
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: '#093458',
      color: 'white',
      fontFamily: 'sans-serif'
    }}>
      <h1>Redirecting to eGATE...</h1>
    </div>
  );
}

export default App;
